import React, { createContext, useContext, useEffect, useState } from "react";
import { AD_VARIANTS, pickVariant } from "@/lib/adVariants";
import { pushDL } from "@/lib/analytics";

const AdVariantContext = createContext({ variantId: null, variant: null });

const STORAGE_KEY = "propertic_ad_variant";

export function AdVariantProvider({ children }) {
  const [variantId, setVariantId] = useState(() => {
    if (typeof window === "undefined") return null;
    return sessionStorage.getItem(STORAGE_KEY) || null;
  });

  useEffect(() => {
    if (typeof window === "undefined") return;
    const params = new URLSearchParams(window.location.search);
    const detected = pickVariant(params);
    const gclid = params.get("gclid");
    const utm_campaign = params.get("utm_campaign") || undefined;
    const utm_source = params.get("utm_source") || undefined;

    if (detected) {
      setVariantId(detected);
      try { sessionStorage.setItem(STORAGE_KEY, detected); } catch { /* ignore */ }
      pushDL("ad_variant", { variant: detected, gclid: gclid || undefined, utm_campaign, utm_source });
    } else if (gclid) {
      // gclid without a recognised campaign — still surface it for attribution
      pushDL("ad_variant", { variant: variantId || "default", gclid, utm_campaign, utm_source });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const variant = variantId ? AD_VARIANTS[variantId] : null;
  return (
    <AdVariantContext.Provider value={{ variantId, variant }}>
      {children}
    </AdVariantContext.Provider>
  );
}

export const useAdVariant = () => useContext(AdVariantContext);
